<div class="auth-shell">
  <app-auth-brand-panel></app-auth-brand-panel>

  <main class="auth-main">
    <div class="auth-topbar">
      <img class="auth-topbar__logo" src="assets/images/logo-ats.png" alt="ATS Informática">
      <span class="auth-topbar__spacer"></span>
      <a class="auth-topbar__ajuda" href="#">
        <mat-icon class="material-symbols-outlined" aria-hidden="true">help</mat-icon>
        Precisa de ajuda?
      </a>
    </div>

    <div class="auth-conteudo">
      <div class="auth-card">
        <ng-content></ng-content>
      </div>
    </div>

    <div class="auth-rodape-compacto">
      <span>© ATS Informática</span>
      <a href="#">Privacidade</a>
    </div>
  </main>
</div>
